import { render, staticRenderFns } from "./InstanceAppSettings.vue?vue&type=template&id=a223b79e&"
import script from "./InstanceAppSettings.vue?vue&type=script&lang=js&"
export * from "./InstanceAppSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports